import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevatedSurfCulture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="68412" id="operational-excellence" className="relative w-full bg-background py-24 lg:py-32 overflow-hidden dark">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://images.unsplash.com/photo-1540962351504-03099e0a754b?q=80&w=2000&auto=format&fit=crop)] bg-cover bg-center opacity-10 grayscale" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-start transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="lg:col-span-3 flex flex-col items-start">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-foreground leading-[0.95] uppercase">
              <span className="block text-primary text-xl md:text-2xl tracking-[0.25em] mb-8">01 / PERSPECTIVE</span>
              <span className="block">Strategic</span>
              <span className="block">Partner</span>
            </h2>
            <div className="h-[2px] w-32 bg-primary mt-8" />
          </div>

          {}
          <div className="lg:col-span-2 flex flex-col gap-8 pt-4 lg:pt-2">
            <p className="text-[20px] leading-relaxed text-foreground/90 font-medium">
              Navigating the complexities of Part 91 and Part 135 operations requires more than just oversight; it demands a partner with deep operational fluency. Starboard Aviation Group serves as the strategic cornerstone for elite flight departments and family offices worldwide.
            </p>
            <p className="text-[20px] leading-relaxed text-foreground/80">
              Our consultancy integrates technical mastery with white-glove execution. From aircraft sourcing to complex multi-jurisdictional management, we provide the elite expertise required to ensure every mission is executed with clinical accuracy, absolute discretion, and unwavering safety.
            </p>
          </div>
        </div>
      </div>
    </section>;
}